import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    height: "100%",
    width: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    position: "absolute",
    top: 0,
    zIndex: theme.zIndex.normal,
    backdropFilter: "blur(3px) brightness(0.4)",
    opacity: 0,
    animation: "$showUp ease-in-out 0.5s 0.5s forwards",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    paddingBottom: 100,
    width: "100%",
    padding: theme.spacing.space16,
  },
  achievementName: {
    marginBottom: theme.spacing.space24,
  },
  tier: {
    marginTop: theme.spacing.space24,
    marginBottom: theme.spacing.space12,
  },
  coins: {
    marginTop: theme.spacing.space16,
    gap: theme.spacing.space24,
  },
  skip: {
    position: "absolute",
    bottom: theme.spacing.space48,
  },
  achieve: {
    height: 140,
    width: 140,
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  currentAchieve: {
    height: 140,
    position: "absolute",
    opacity: 1,
    animation: "$hideCurrentAchieve ease-in-out 0.2s 1s forwards",
  },
  nextAchieve: {
    height: 140,
    opacity: 0,
    position: "absolute",
    animation: "$showNextAchieve ease-in-out 0.2s 1.5s forwards",
  },
  nextTierCard: {
    position: "absolute",
    bottom: "-110%",
    animation: "$showNextTier ease-in-out 0.3s 2.6s forwards",
    width: `calc(100% - ${theme.spacing.space32}px)`,
  },
  "@keyframes showNextTier": {
    "0%": {
      bottom: "-110%",
    },
    "100%": {
      bottom: "0%",
    },
  },
  "@keyframes hideCurrentAchieve": {
    "0%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
  "@keyframes showNextAchieve": {
    "0%": {
      opacity: 0,
      transform: "scale(0)",
    },
    "80%": {
      transform: "scale(1.3)",
    },
    "100%": {
      opacity: 1,
      transform: "scale(1)",
    },
  },
  "@keyframes showUp": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
}));
